import NpsByDeviceWidget from './NpsByDeviceWidget';
export default NpsByDeviceWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/NpsByDeviceWidget/index.js